import React from 'react'
import { ProgressOverviewConfigForm } from './components/ProgressOverviewConfigForm'
import { ProgressReportByProcessConfigForm } from './components/ProgressReportByProcessConfigForm'
import { ProgressReportByTeamConfigForm } from './components/ProgressReportByTeamConfigForm'
import { EmptyConfigContainer, EmptyConfigText } from './styles'
import { VersionReportVersionPageFormModel } from '../../model/VersionReportVersionPageFormModel'

const PAGE_CONFIG_COMPONENTS = {
  PROGRESS_OVERVIEW: ProgressOverviewConfigForm,
  PROGRESS_REPORT_BY_PROCESS: ProgressReportByProcessConfigForm,
  PROGRESS_REPORT_BY_TEAM: ProgressReportByTeamConfigForm,
} as const

type ConfigFormProps = {
  page: VersionReportVersionPageFormModel
  snapshotUuid: string
  onUpdate: (
    pageNumber: number,
    updater: (
      prev: VersionReportVersionPageFormModel
    ) => VersionReportVersionPageFormModel
  ) => void
}

export const PageConfigForm: React.FC<ConfigFormProps> = ({
  page,
  snapshotUuid,
  onUpdate,
}) => {
  const ConfigComponent = PAGE_CONFIG_COMPONENTS[page.pageType]

  if (!ConfigComponent) {
    return (
      <EmptyConfigContainer>
        <EmptyConfigText>
          選択されたページタイプの設定フォームはまだ実装されていません
        </EmptyConfigText>
      </EmptyConfigContainer>
    )
  }

  return (
    <ConfigComponent
      page={page}
      snapshotUuid={snapshotUuid}
      onUpdate={onUpdate}
    />
  )
}
